import { ApiClient } from './client';

// Search plugin uses /api-bf/ base URL
const SEARCH_BASE_URL = 'https://' + import.meta.env.VITE_BACKEND_CUSTOM_DOMAIN_NAME + '/api-bf/';

const client = new ApiClient(SEARCH_BASE_URL);

export const searchApi = {
  get: async <T>(endpoint: string) => {
    return client.get<T>(endpoint);
  },
  post: async <T>(endpoint: string, data?: unknown) => {
    return client.post<T>(endpoint, data);
  },
};
